import { render, staticRenderFns } from "./HistoricoVeiculo.vue?vue&type=template&id=1cdd65cb"
import script from "./HistoricoVeiculo.vue?vue&type=script&lang=js"
export * from "./HistoricoVeiculo.vue?vue&type=script&lang=js"
import style0 from "./HistoricoVeiculo.vue?vue&type=style&index=0&id=1cdd65cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports